import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectTelnyxPhoneNumbers = createSelector(
  getCompany,
  ({ telnyxPhoneNumbers }) => telnyxPhoneNumbers,
);

export const selectOwnedPhoneNumbers = createSelector(
  selectTelnyxPhoneNumbers,
  ({ ownedNumbers }) => ownedNumbers,
);

export const selectAvailableNumbers = createSelector(
  selectTelnyxPhoneNumbers,
  ({ searchResults }) => searchResults,
);

export const selectPhoneNumbersIsSearching = createSelector(
  selectTelnyxPhoneNumbers,
  ({ isSearching }) => isSearching,
);

export const selectPhoneNumbersIsOrdering = createSelector(
  selectTelnyxPhoneNumbers,
  ({ isOrdering }) => isOrdering,
);

export const selectOrderStatus = createSelector(
  selectTelnyxPhoneNumbers,
  ({ orderStatus }) => orderStatus,
);
